import React from "react";
import { Box, Typography, Button, useTheme } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutlineRounded";

const NotFound = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        backgroundColor: theme.palette.background.default,
        padding: 3,
      }}
    >
      <ErrorOutlineIcon
        sx={{
          fontSize: 120,
          color: theme.palette.primary.main,
          mb: 3,
        }}
      />
      <Typography
        variant="h1"
        sx={{
          fontSize: "6rem",
          fontWeight: "bold",
          color: theme.palette.primary.main,
          mb: 1,
        }}
      >
        404
      </Typography>
      <Typography
        variant="h4"
        sx={{
          color: theme.palette.text.primary,
          mb: 2,
        }}
      >
        Page Not Found
      </Typography>
      <Typography
        variant="body1"
        sx={{
          color: theme.palette.text.secondary,
          mb: 4,
          textAlign: "center",
          maxWidth: "500px",
        }}
      >
        The page you're looking for doesn't exist or you don't have permission
        to access it.
      </Typography>
      <Button
        variant="contained"
        onClick={() => navigate("/dashboard")}
        sx={{
          backgroundColor: theme.palette.primary.main,
          color: theme.palette.background.default,
          "&:hover": {
            backgroundColor: theme.palette.primary.dark,
          },
          px: 4,
          py: 1.5,
          borderRadius: 2,
        }}
      >
        Go to Dashboard
      </Button>
    </Box>
  );
};

export default NotFound;
